import * as React from 'react';

import './styles.scss';

export interface ICollapsibleBodyProps {
    /** Open state */
    open?: boolean;
    /** Toggle action */
    toggle?: () => void;
    /** Layouts to choose from */
    layout?: 'default' | 'menu-item' | 'filter-group';
}

/**
 * Collapsible component body.
 */
export const CollapsibleBody: React.FunctionComponent<ICollapsibleBodyProps> = (props) => {
    if (!props.open) {
        return null;
    }
    return (
        <div className="collapsible-body">
            {props.children}
        </div>
    );
};

CollapsibleBody.displayName = 'CollapsibleBody';

export default CollapsibleBody;
